import { NeoModel, ModelBase, Validation, Rules } from "@singularsystems/neo-core";

@NeoModel
export default class OrganisationSettingLookup extends ModelBase {

    public organisationSettingId: number = 0;

    public organisationId: number = 0;

    public attribute: string = "";

    public value: string = "";

    public organisationName: string = "";
}